import React from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


// config file
const DeleteRowModal = (props) => {


    const deleteSelectedRow = () => {
        props.deleteSelectedRow();
    }


    return (
        <div>

            <Dialog
                visible={props.openDeleteModal}
                draggable={false}
                style={{ width: '30vw' }}
                closable={false}
                headerStyle={{ display: 'none' }}
                closeOnEscape={false}
            >
                {/* Modal is not using For now */}
                {/* <Modal isOpen={props.openDeleteModal}
                className='modal-dialog-centered modal-dialog--primary m-auto logout_modal_width'
            > */}
                <ModalBody className='deleteModalBody text-center mt-4  mb-0'>
                    <div style={{ marginBottom: 10 }}>Are you sure you want to Delete?</div>
                    <Button color="primary" outline onClick={props.closeDeleteModal} className='deleteModalBtn marginRight'>No</Button>
                    <Button color="primary" outline onClick={deleteSelectedRow}
                        className='deleteModalBtn'>Yes</Button>
                </ModalBody>
                {/* </Modal> */}
            </Dialog>
        </div>
    );

}


export default DeleteRowModal;